/**
 * Mixin reutilizável para CRUDs com tabela server-side (paginação + exportação CSV/PDF).
 *
 * O componente que usar este mixin deve ter:
 * - data: pageNumber, numberOfRows, serverSortBy, serverSortDesc, searchFilters, lastItemsPerPageBeforeTodos, total (nome do total é do componente, ex: totalUsuarios/totalPessoas)
 * - methods: serverTableLoad(options) — GET da página atual
 * - methods: loadItemsForExport(onProgress) — preferir fetchAllServerPagesForExport (utils/serverTablePagination)
 *   e passar via CadastroToolbar :load-items-for-export (não usar update:displayedItems da página atual)
 *
 * Este mixin fornece: onTableOptions(opts), onFiltersUpdate(filters).
 */

import { samePageAndSort } from '@/utils/serverTablePagination';

export default {
  methods: {
    /** Filtros não-coluna (ex.: somente_ativas, id_linha). Cada CRUD pode sobrescrever. */
    serverTableBaseFilters() {
      return {};
    },
    onTableOptions(opts) {
      // Evita requisição duplicada quando a tabela emite update:options enquanto já há um load em andamento (ex.: initialize() acabou de chamar serverTableLoad).
      if (this.loadingtable) return;
      if (!opts) {
        this.serverTableLoad(opts);
        return;
      }
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
      };
      if (samePageAndSort(opts, state) && !this.loadingtable) {
        return;
      }
      this.serverTableLoad(opts);
    },
    onFiltersUpdate(filters) {
      const next = Object.assign(this.serverTableBaseFilters(), filters || {});
      if (JSON.stringify(next) === JSON.stringify(this.searchFilters)) return;
      this.searchFilters = next;
      this.pageNumber = 1;
      this.serverTableLoad();
    },
  },
};
